import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DialogComponent } from '../custom-components/dialog/dialog.component';
import { DialogTipo } from '../custom-components/dialog/utils/dialog-type.enum';
import { SessionService } from '../services/session.service';
import { SnackbarService } from '../services/snackbar-service.service';
import { DialogSuccessComponent } from '../shared/components/dialog-succes/dialog-success.component';
import { PasswordValidator } from '../_helpers/password.validator';
import { PasswordResetService } from './password-reset.service';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit, OnDestroy {

  // ocultar mostrar password
  hideCurrent = true;
  hideNew = true;
  hideRepeat = true;

  form: FormGroup;
  repForm: FormGroup;
  //Variable para saber si se esta enviando la peticion
  inSubmission = false;

  $unsubscribe = new Subject<any>();

  errorsMsg = [
    { type: 'required', message: 'Contraseña requerida.' },
    {
      type: 'minlength',
      message: 'Mínimo 6 caracteres',
    },
    {
      type: 'pattern',
      message: 'Debe ingresar al menos una letra mayúscula, una minúscula y un número, no se permiten caracteres especiales',
    },
  ]

  errorsRepMsg = [
    { type: 'required', message: 'Contraseña requerida.' },
    {
      type: 'minlength',
      message: 'Mínimo 6 caracteres',
    },
    {
      type: 'pattern',
      message: 'Debe ingresar al menos una letra mayúscula, una minúscula y un número, no se permiten caracteres especiales',
    },
    {
      type: 'areEqual',
      message: 'Las constraseñas no coinciden'
    },
  ];

  @Input() token: string;
  @Input() mensaje: string = null;
  @Input() loginPage = false;

  constructor(
    private fb: FormBuilder,
    private snackbar: SnackbarService,
    private passwordSvc: PasswordResetService,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<PasswordResetComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any = null,
    private router: Router,
    private sessionService: SessionService
  ) { }

  ngOnInit(): void {
    if (this.data) {
      this.token = this.data.token;
      this.mensaje = this.data.mensaje;
      this.loginPage = this.data.loginPage;
    }
    this.buildForm();
  }

  ngOnDestroy() {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }

  /**
   * Construccion del formulario
   */
  buildForm() {

    // clave actual
    this.form = this.fb.group({
      claveActual: new FormControl(
        '',
        Validators.compose([
          Validators.minLength(6),
          Validators.required,
          // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$'),
        ])
      ),
    });

    // nueva clave y confirmacion
    this.repForm = new FormGroup({
      claveNueva: new FormControl('', Validators.compose([
         Validators.minLength(6),
         Validators.required,
         Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$')
      ])),
      repetirClave: new FormControl('', Validators.compose([
        Validators.minLength(6),
        Validators.required,
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$')
      ]))
    }, (formGroup: FormGroup) => {
       return PasswordValidator.areEqual(formGroup);
    });

    // lectura en tiempo real para actualizar estados y mostrar distintos errores
    this.form.controls.claveActual.valueChanges.subscribe( val => {
      this.form.controls.claveActual.markAsTouched();
    });
    this.repForm.controls.claveNueva.valueChanges.subscribe( val => {
      this.repForm.controls.claveNueva.markAsTouched();
      if (val !== this.repForm.controls.repetirClave.value) {
        this.repForm.controls.repetirClave.setErrors({areEqual: true})
      }
    });
    this.repForm.controls.repetirClave.valueChanges.subscribe( val => {
      this.repForm.controls.repetirClave.markAsTouched();
      if (val !== this.repForm.controls.claveNueva.value) {
        this.repForm.controls.repetirClave.setErrors({areEqual: true})
      }
    });

  }

  /**
   * Envio del formulario al BE
   * @returns no retona datos
   */
  sendForm(): void {
    this.inSubmission = true;
    if (this.form.invalid || this.repForm.invalid) {
      this.snackbar.showMessage('Favor verifique campos requeridos', 'warning');
      this.inSubmission = false;
      this.form.markAllAsTouched();
      this.repForm.markAllAsTouched();
      return;
    }

    const body = {
      claveActual: this.form.controls.claveActual.value,
      nuevaClave: this.repForm.controls.claveNueva.value,
    }

    this.passwordSvc.cambiarClave(body, this.token).pipe(takeUntil(this.$unsubscribe)).subscribe( () => {
      this.inSubmission = false;
      if (this.loginPage) {

        this.dialog.open(DialogComponent, {
          data: {
            toolbarTitulo: 'Cambio de contraseña exitoso',
            mensaje: 'Vuelva a iniciar sesión con su nueva clave',
            tipo: DialogTipo.INFO
          },
          disableClose: true
        }).afterClosed().subscribe( () => this.goLogin());
      }

      this.snackbar.showMessage('Cambio de clave exitoso');
      this.dialogRef.close();
    },error => {
      this.inSubmission = false;
    });


  }

  goLogin(): void {
    this.sessionService.logout();
  }

}
